<template>
  <time :datetime="date">
    {{ formattedDate }}
  </time>
</template>

<script setup lang="ts">
import type { ITeaser, TArticle } from '~~/types/local_types';

const props = defineProps<TArticle | ITeaser>();
const { date, formattedDate } = useArticleData(props);
</script>

<style scoped lang="postcss"></style>
